import { useQuery, keepPreviousData } from '@tanstack/react-query';

import { getConsumerTableData, getConsumptionChartData } from '@/api/services/consumer/consumer.service';

import { QUERY_KEYS } from '@/api/config/query-keys';

import type { ConsumerUrls } from '../types/consumer.types';

export const useConsumerData = (urls: ConsumerUrls | null, cacheKey: string | null, shouldLoadData: boolean) => {
  const tableDataQuery = useQuery({
    queryKey: [QUERY_KEYS.CONSUMER_TABLE, cacheKey],
    queryFn: () => getConsumerTableData(urls!.tableUrl),
    enabled: Boolean(shouldLoadData && urls?.tableUrl && cacheKey),
    retry: false,
    placeholderData: keepPreviousData,
    staleTime: 0,
  });

  const chartDataQuery = useQuery({
    queryKey: [QUERY_KEYS.CONSUMER_CHART, cacheKey],
    queryFn: () => getConsumptionChartData(urls!.chartUrl),
    enabled: Boolean(shouldLoadData && urls?.chartUrl && cacheKey),
    retry: false,
    placeholderData: keepPreviousData,
    staleTime: 0,
  });

  return {
    tableDataQuery,
    chartDataQuery,
    isLoading: tableDataQuery.isFetching || chartDataQuery.isFetching,
    isError: tableDataQuery.isError || chartDataQuery.isError,
    isChartFetching: chartDataQuery.isFetching,
  };
};
